import React from 'react'
import ReactDOM from 'react-dom/client'
import './css/index.css'
import App from './App'
import { ConsentProvider } from './components/ConsentProvider'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <ConsentProvider>
        <App />
    </ConsentProvider>
)
